import { render } from "./nxUserShow.vue?vue&type=template&id=6c690230"
import script from "./nxUserShow.vue?vue&type=script&lang=js"
export * from "./nxUserShow.vue?vue&type=script&lang=js"

import "./nxUserShow.vue?vue&type=style&index=0&id=6c690230&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__